export default __webpack_public_path__ + "static/media/logo.7756c8d8.svg";